<template>
  <BuilderBtnItem
    icon="save"
    title="Save"
    :disabled="disabledSaving"
    :icon-size="iconSize"
    :button-state="buttonState"
    @click="save"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderBtnItem from '@/components/builder/BuilderNav/BuilderBtnItem.vue'
import { ButtonStates } from '@/types'
import { useBuilderStore } from '@/store/admin/builder'

const components = {
  BuilderBtnItem,
}

const props = {
  disabled: Boolean,
  iconSize: {
    type: String,
    default: '',
  },
}

@Component({ components })
export default class BuilderNavSave extends Vue.extend({ props }) {
  builder = useBuilderStore()

  mounted () {
    this.$root.$on('save-version', this.save)
  }

  get disabledSaving () {
    if (this.buttonState === ButtonStates.PROCESSING) return true
    return this.disabled
  }

  get buttonState () {
    return this.builder.buttonState
  }

  async save () {
    await this.builder.save({
      saveSuccess: this.saveSuccess,
      saveFail: this.saveFail,
      imageUploadRequired: this.imageUploadRequired,
    })
  }

  saveSuccess () {
    this.$typedStore.primary.entities.nodes.resetNodeModifications()
    this.$analytics.event('save', {
      event_category: 'version-save',
      event_label: `version-${this.$route.params.primaryVersionId}`,
      event_result: 'success',
    })
  }

  saveFail () {
    this.$analytics.event('save', {
      event_category: 'version-save',
      event_label: `version-${this.$route.params.primaryVersionId}`,
      event_result: 'failure',
    })
  }

  imageUploadRequired () {
    this.$bvModal.show('SaveImageModal')
    this.$analytics.event('save', {
      event_category: 'version-save',
      event_label: `version-${this.$route.params.primaryVersionId}`,
      event_result: 'images',
    })
  }
}

</script>
